import { useState, useCallback } from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

export type AlertMessage = {
    id: number;
    message: string;
    severity?: AlertColor;
    autoHideDuration?: number;
};

export const useMessage = () => {
    const [ messages, setMessages ] = useState<AlertMessage[]>([]);

    const showMessage = useCallback((message: string, severity: AlertColor = 'info', autoHideDuration: number = 3000) => {
        setMessages(prev => [ ...prev, { id: Date.now(), message, severity, autoHideDuration } ]);
    }, []);

    const MessageContainer = () => (
        <>
            {messages.map(message => (
                <Snackbar
                    key={message.id}
                    open
                    autoHideDuration={message.autoHideDuration}
                    onClose={() => setMessages(prev => prev.filter(p => p.id !== message.id))}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert
                        onClose={() => setMessages(prev => prev.filter(p => p.id !== message.id))}
                        severity={message.severity}
                        sx={{ width: '100%' }}
                    >
                        {message.message}
                    </Alert>
                </Snackbar>
            ))}
        </>
    );

    return { showMessage, MessageContainer };
};